import {CreateZone, DeleteZone, ListZone, UpdateZone} from "@/api/zone";

const state = () => ({
  zones: [],
  total: 0,
})

// getters
const getters = {}

// actions
const actions = {
  async fetchZones( { commit, dispatch }, params ) {
    await dispatch("loading/setLoading", true, {root: true})
    ListZone(params).then((data) => {
      commit('setZones', data.data.data.data)
      commit('setTotal', data.data.data.total)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async createZone( { dispatch }, params ) {
    await dispatch("loading/setLoading", true, {root: true})
    CreateZone(params).then((data) => {
        console.log("createZone, data=", data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async updateZone( { dispatch }, params ) {
    await dispatch("loading/setLoading", true, {root: true})
    UpdateZone(params).then((data) => {
        console.log("updateZone, data=", data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async deleteZone( { dispatch }, params ) {
    await dispatch("loading/setLoading", true, {root: true})
    DeleteZone(params).then((data) => {
        console.log("DeleteZone, data=", data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
}

// mutations
const mutations = {
  setZones (state, zones) {
    console.log("zones= ", zones)
    state.zones = zones
  },
  setTotal (state, total) {
    state.total = total
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
